import React from "react";
import {
    CartPageContent
} from "@shopcrate/shopcrate-framework";

import Helmet from "../../../components/Helmet";

import bannerImage from "../../../img/top_10_kantoorplanten.jpg";

function Cart() {
    return (
        <React.Fragment>
            <Helmet title="Winkelwagen"/>
            <div className="jumbotron jumbotron-fluid jumbotron-header jumbotron-sm" style={ { backgroundImage: "url(" + bannerImage + ")" } }>
                <div className="container">
                    <h1 className="text-white">Winkelwagen</h1>
                </div>
            </div>
            <div className="container mb-5">
                <CartPageContent/>
            </div>
        </React.Fragment>
    )
}

export default React.memo(Cart);
